import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useUpdateLocationDetail = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updateLocationDetails', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: ['locations'] });
      await revalidate(['locations', 'all']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync, isPending };
};

export default useUpdateLocationDetail;
